import {BreakpointObserver} from '@angular/cdk/layout';
import {Component, OnInit} from '@angular/core';
import {ResponsiveMode} from '../../../models/responsive-mode.type';
import {SassHelperComponent} from '../../../providers/sass-helper/sass-helper.component';
import {SupporterContactInfoModel} from '../../../../auth/models/supporter-contact-info.model';
import {AuthFacade} from '../../../../auth/facade/auth.facade';

@Component({
  selector: 'morva-error500',
  templateUrl: './error500.component.html',
  styleUrls: ['./../error.scss'],
})
export class Error500Component implements OnInit {
  supporterContactInfo: SupporterContactInfoModel = {contactInfoType:'' ,email: '', phoneNumber: ''};
  responsiveMode: ResponsiveMode;
  private sassHelper: SassHelperComponent;

  constructor(private breakPointObserver: BreakpointObserver, private authFacade: AuthFacade) {
    this.sassHelper = new SassHelperComponent();
  }

  ngOnInit(): void {
    this.breakPointObserver.observe([this.sassHelper.mdMaxWidth]).subscribe(state => {
      if (state.breakpoints[this.sassHelper.mdMaxWidth]) {
        this.responsiveMode = 'md';
      } else {
        this.responsiveMode = 'lg';
      }
    });
    this.getSupporterContactInfo();
  }

  getSupporterContactInfo() {
    this.authFacade.getSupporterContactInfo().subscribe(res => {
      this.supporterContactInfo = res;
    });
  }
}
